/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG} from '../../../../common/constants';
import {MarketAreaService} from '../../../../services/market-area.service';
import {SubregionService} from '../../../../services/subregion.service';

@Component({
    selector: 'app-add-planning-market-pop-up',
    templateUrl: './add-planning-market-pop-up.component.html',
    styleUrl: './add-planning-market-pop-up.component.scss',
    standalone: false
})
export class AddPlanningMarketPopUpComponent {
  planningMarketName: string;
  subregions: any[];
  marketAreas: string[];
  selectedSubregion: any;
  selectedMarketArea: string;

  showSpinner: boolean;


  constructor(public readonly subregionService: SubregionService,
              public readonly marketAreaService: MarketAreaService,
              public dialogRef: MatDialogRef<AddPlanningMarketPopUpComponent>,
              public snackBar: FabMessageService) {
    this.getSubregions();
  }

  /**
   * Gets the subregions
   */
  getSubregions() {
    this.showSpinner = true;
    this.subregionService.getSubregions().subscribe({
        next: (response) => {
          this.subregions = response;
        },
        error: () => {
          this.showSpinner = false;
          this.snackBar.displayError('Error loading subregions', DISMISS_MSG);
        },
        complete: () => {
          this.showSpinner = false;
        }
      }
    );

  }

  /**
   * Gets the market areas that are in the region of the selected subregion
   */
  getMarketAreas() {
    this.selectedMarketArea = null;
    this.showSpinner = true;
    this.marketAreaService.getMarketAreasByRegion(this.selectedSubregion.region).subscribe({
        next: (response) => {
          this.marketAreas = response;
        },
        error: () => {
          this.showSpinner = false;
          this.snackBar.displayError('Error loading Market Areas', DISMISS_MSG);
        },
        complete: () => {
          this.showSpinner = false;
        }
      }
    );
  }

  /**
   * Adds a new planning market
   */
  addPlanningMarket(): void {
    this.dialogRef.close({
      data: {
        planningMarketName: this.planningMarketName,
        subregion: this.selectedSubregion.subregionValue,
        marketArea: this.selectedMarketArea
      }
    });
  }
}
